module.exports = __webpack_public_path__ + "img/arptc.7e19df38.png";